import React from 'react';
import { Link } from 'react-router-dom';

const year = new Date().getFullYear();

const Footer: React.FC = () => (
  <footer className="gv-footer" role="contentinfo">
    <div className="gv-footer-inner">
      <div className="rm-disclaimer">
        <strong>Data freshness:</strong> GammaVision streams dealer GEX/VEX exposure on a polling cadence (default 30 s).
        Quotes are delayed up to one minute and may differ from official exchange feeds. Refresh the page if your tab has been idle.
      </div>
      <div className="rm-disclaimer">
        <strong>Not investment advice:</strong> GammaVision is an analytical tool. Nothing here is a recommendation to buy, sell, or hold any security.
        Options trading involves substantial risk and is not suitable for every investor. Verify all numbers against your broker before acting.
      </div>
      <div className="gv-footer-row">
        <div className="gv-footer-links">
          <Link to="/">Home</Link>
          <Link to="/pricing">Pricing</Link>
          <Link to="/faq">FAQ</Link>
          <Link to="/terms">Terms</Link>
          <Link to="/privacy">Privacy</Link>
          <a href="mailto:support@gammavision.app">Contact</a>
        </div>
        <div className="gv-footer-copy">© {year} GammaVision · Built for traders who watch dealer flow.</div>
      </div>
    </div>
  </footer>
);

export default Footer;
